import { useMemo } from 'react'
import { useDispatch } from 'react-redux'
import { deleteCurrentRound as deleteCurrentRoundAction } from 'src/actions/assetRounds'
import { SET_SELECTED_ASSET_ROUND_ID } from 'src/actions/types'
import useReduxAssetSystem from 'src/new_arch/modules/projectView/hooks/useReduxAssetSystem'
import useAssetSystem from 'src/new_arch/modules/projectView/systems/useAssetSystem'
import useSnackbarSystem from '@ui/systems/useSnackbarSystem'
import { useRootStore } from 'src/new_arch/providers/RootStoreProvider'
import type Asset from 'src/new_arch/modules/projectView/models/asset'

import UndoableDeleteSystem from './UndoableDeleteSystem'

const useUndoableDeleteSystem = () => {
	const dispatch = useDispatch()
	const assetSystem = useReduxAssetSystem()
	const assetQuerySystem = useAssetSystem()
	const snackbarSystem = useSnackbarSystem()
	const { pendingDeletesStore } = useRootStore()

	return useMemo(
		() => new UndoableDeleteSystem( {
			store: pendingDeletesStore,
			snackbarSystem,
			assetSystem,
			selectAssetRound: ( roundID: number ) => {
				dispatch( { type: SET_SELECTED_ASSET_ROUND_ID, payload: roundID } )
			},
			deleteCurrentRound: ( asset: Asset ) => (
				dispatch( deleteCurrentRoundAction( asset ) as never ) as unknown as Promise<unknown>
			),
			fetchAssetRounds: ( assetID: number ) => assetQuerySystem.fetchAssetRounds( { assetID } )
		} ),
		[ assetSystem, assetQuerySystem, snackbarSystem, pendingDeletesStore, dispatch ]
	)
}

export default useUndoableDeleteSystem
